export default __webpack_public_path__ + "static/media/recharge-all.1b350a91.svg";